import axios from 'axios';
import Cookies from 'js-cookie';
import Api from './ApiUrl'
const API_URL = `${Api}/api/v1/categories`;



export const getCategories = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};
export const getCategory = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};
export const getCategoryById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};
export const createCategory = async (category) => {
  const response = await axios.post(API_URL, category);
  return response.data;
};

export const updateCategory = async (id, category) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${JSON.parse(Cookies.get('token'))}`,
    },
    
  };
  console.log(category)
  const response = await axios.put(`${API_URL}/${id}`, category,config);
  return response.data;
};

export const deleteCategory = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`);
  return response.data;
};
